module.exports = __webpack_public_path__ + "static/media/skjelven.a83ef09d.mp3";